import { Pipe, PipeTransform } from '@angular/core';

import { isArray, isEmpty, isNil, isString } from 'lodash-es';

@Pipe({
  name: 'redDashIfEmpty',
  standalone: false
})
export class DashIfEmptyPipe implements PipeTransform {
  transform(value: string | number | undefined | null) {
    let result = value;

    if (isNil(value) || (isString(value) && isEmpty(value)) || (isArray(value) && isEmpty(value)) || value === 'N/A') {
      result = '--';
    }

    return result;
  }
}
